export const situationsKeys = {
  all: ["situations"] as const,
  list: () => [...situationsKeys.all, "list"] as const,
};
